import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { images } from "../../../assets/AssetHelper";
import { detailsData } from "./details";

const UsersOccasionsTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  rolesOptions,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("users_occasions.title"),
            data: {
              images: [{ id: 0, img: images.Logo }],
              list: detailsData({ data: details, t }),
            },
          }}
          table={{
            list: data,
            listTitle: t("users_occasions.title"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "localized_data.en.name",
                Header: t("users_occasions.occasion_name_en"),
                sort: true,
              },
              {
                accessor: "occasion_type.name",
                Header: t("users_occasions.occasion_type"),
                sort: true,
              },
              {
                accessor: "updated_at",
                Header: t("users_occasions.updated_at"),
                sort: true,
              },
              {
                accessor: "customer.name",
                Header: t("users_occasions.customer"),
              },
              { accessor: "Actions", Header: t("common.action_actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: t("users_occasions.search_placeholder"),
            isChecked: false,
            total_count: count,
            isSort: true,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list
            headerChildren,

            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(supportedLang, rolesOptions),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id ? t("users_occasions.edit") : t("users_occasions.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default UsersOccasionsTemplate;
